import instituteMemberAPI from '@/services/api/institute/member'

const instituteMember = {
	namespaced: true,
	state: {
		tab: 1,
		memberList: {
			count: 0,
			members: [],
		},
		member: {},
	},
	getters: {
		getTab: state => state.tab,
	},
	mutations: {
		setTab: (state, payload) => {
			state.tab = payload
		},
		setMemberList: (state, payload) => {
			state.memberList = payload
		},
		addMemberList: (state, payload) => {
			state.memberList.members = [...state.memberList.members, ...payload]
		},
	},
	actions: {
		loadMemberList: async ({ commit }, payload) => {
			const { instId, offset, length, keyword } = payload
			const response = await instituteMemberAPI.lookupMemberList(
				instId,
				offset,
				length,
				keyword
			)
			commit('setMemberList', response.data)
		},
		addMemberList: async ({ commit }, payload) => {
			const { instId, offset, length, keyword } = payload
			const response = await instituteMemberAPI.lookupMemberList(
				instId,
				offset,
				length,
				keyword
			)
			commit('addMemberList', response.data.members)
		},
		loadMember: async ({ commit }, payload) => {
			const { instId, id } = payload
			const response = await instituteMemberAPI.lookupMember(instId, id)
			commit('setMember', response.data)
			// const response = await instituteMemberAPI.lookupMember(
			//     instId,
			//     id
			// )
			// commit('setMember', response.data);
		},
		updateMember: async ({ commit }, payload) => {
			const { instId, body } = payload
			const response = await instituteMemberAPI.updateMember(instId, body)
			commit('setMemberList', response.data)
		},
		deleteMember: async ({ commit }, payload) => {
			const { instId, ids } = payload
			const response = await instituteMemberAPI.deleteMember(instId, ids)
			commit('setMemberList', response.data)
		},
	},
}

export default instituteMember
